(function () {
  'use strict';

  function initTabs() {
    document.querySelectorAll('[data-grm-tabs]').forEach(function (tabGroup) {
      var tabs = tabGroup.querySelectorAll('[data-grm-tab]');
      var panelContainer = document.getElementById(tabGroup.getAttribute('data-grm-tabs'));
      if (!panelContainer) return;
      var panels = panelContainer.querySelectorAll('[data-grm-panel]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-grm-tab');

          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');

          panels.forEach(function (p) {
            if (p.getAttribute('data-grm-panel') === target) {
              p.classList.add('is-active');
            } else {
              p.classList.remove('is-active');
            }
          });
        });

        tab.addEventListener('keydown', function (e) {
          var idx = Array.from(tabs).indexOf(tab);
          var next;
          if (e.key === 'ArrowRight') next = tabs[(idx + 1) % tabs.length];
          if (e.key === 'ArrowLeft') next = tabs[(idx - 1 + tabs.length) % tabs.length];
          if (next) {
            e.preventDefault();
            next.focus();
            next.click();
          }
        });
      });
    });
  }

  function initAccordions() {
    document.querySelectorAll('[data-grm-accordion]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var panelId = trigger.getAttribute('aria-controls');
        var panel = document.getElementById(panelId);
        if (!panel) return;

        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!isOpen));
        panel.classList.toggle('is-open', !isOpen);
      });
    });
  }

  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#grm-"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var target = document.querySelector(link.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initTabs();
      initAccordions();
      initSmoothScroll();
    });
  } else {
    initTabs();
    initAccordions();
    initSmoothScroll();
  }
})();
